import { useTranslation } from "react-i18next";
import AboutUsImg from '@/assets/images/norrskenabout.jpg'

export default function AboutStory() {
  const { t } = useTranslation();

  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="w-full px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative rounded-3xl overflow-hidden h-80 lg:h-[520px]">
            <img
              src={AboutUsImg}
              alt="AIP Office Kigali"
              loading="lazy"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-6 left-6 bg-white rounded-xl px-5 py-3 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-[#f5f5f0] rounded-lg">
                <i className="ri-map-pin-2-fill text-xl text-[#00C2C2]" />
              </div>
              <div>
                <p className="text-[#0A1628] font-bold text-sm">{t("storyHQLabel")}</p>
                <p className="text-gray-500 text-xs">{t("storyHQCity")}</p>
              </div>
            </div>
          </div>

          <div>
            <p className="text-[#00C2C2] text-xs font-semibold tracking-widest uppercase mb-4">{t("storyTag")}</p>
            <h2 className="text-4xl font-bold text-[#0A1628] leading-tight mb-6">
              {t("storyTitle")}<br />{t("storyTitleAccent")}
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-5">
              {t("storyP1")}
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              {t("storyP2")}
            </p>
            <div className="grid grid-cols-3 gap-5">
              {[
                { value: "2012", label: t("storyStatFounded") },
                { value: "7+", label: t("storyStatCountries") },
                { value: "500+", label: t("storyStatClients") },
              ].map((s) => (
                <div key={s.label} className="text-center bg-[#f8fafc] rounded-xl p-4">
                  <div className="text-2xl font-bold text-[#0A1628] mb-1">{s.value}</div>
                  <p className="text-gray-500 text-xs">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
